<template>
  <div class="page">
    <div class="row--central mv4 mh2">
      <img
        class="image--circle image--size-x-3"
        :src="linePictureUrl"
        @error="$event.target.src = clinic.urls.substitute"
      >
      <div class="column--central">
        <font-awesome-icon
          :icon="['fas', 'angle-double-right']"
          class="mh8"
        />
      </div>
      <img
        class="image--circle image--size-x-3"
        :src="clinic.urls.logo"
      >
    </div>
    <div class="page__text">
      <div>{{ clinic.金安心.fullname }} 網路服務約定條款</div>
      <div class="align--left mh2">
        <br>歡迎使用{{ clinic.金安心.fullname }} LINE 官方帳號功能服務；請您先詳細閱讀以下約定條款：
        <br>
        本約定條款適用於{{ clinic.金安心.fullname }} LINE 官方帳號功能服務（以下稱本系統），
        本系統的服務是由『{{ clinic.金安心.fullname }}』（下稱本院所）所建置提供。
        本約定條款的目的，是為了保護「{{ clinic.金安心.fullname }}」以及您的利益，
        如果您點選「個人服務」、「開始連結」或類似語意的選項、或在本系統進行登入、查閱、修改資料等相關行為，
        就視為您事先已經知悉、並同意本約定條款的所有約定。
        <br>
        <br>
        一、使用者 <br>1.
        如果您要在{{ clinic.金安心.fullname }} LINE 官方帳號功能服務查詢個人醫療資訊時，
        您必須在首次認證作業中填寫「身分證」、「西元出生日期」、「手機號碼」，
        使用個人手機取得驗證碼後驗證成功，成功綁定資訊。
        並同意日後以身份證號碼或其它合法證照號碼、出生日期於本系統進行相關醫療資訊查詢作業。
        <br>2.
        您有自行妥善保管您留存於本系統之個人資訊之義務，不得將該個人資訊透露或提供給第三人知悉、或出借或轉讓第三人使用。
        對於所有您使用功能，本服務系統所為之一切行為，都視為您自己之行為，並應由您負其責任。
        <br>
        <br>二、查詢資訊功能 <br>1.
        {{ clinic.金安心.fullname }} LINE 官方帳號功能服務將確保本系統具有符合一般可合理期待之安全性；
        但本系統不以任何明示或默示的方式擔保您所傳輸的資料將被正常顯示或處理、亦不擔保資料傳輸的正確性，
        如果您發現本系統有錯誤或疏失，請立即通知{{ clinic.金安心.fullname }}。
        <br>2.
        本系統會定期備份資料（除超音波影像下載功能資訊），但是除因故意或重大過失所致者外，
        {{ clinic.金安心.fullname }}不對任何資料的失誤刪除、或備份錯誤或失敗負責。
        <br>
        <br>三、個人資料安全
        <br>依據中華民國個人資料保護法（以下稱個資法）第八條第一項規定，為了確保使用者之個人資料、隱私及權益之保護，
        當您已申請「{{ clinic.金安心.fullname }} LINE 官方帳號功能服務」時，
        即表示您願意以電子文件之方式行使法律所賦予同意之權利，並具有書面同意之效果，
        若不同意請勿申請帳號來進行資訊查詢，如仍需其它服務，請連繫本院所，我們將竭誠為您服務。
        (以下為本院所依「個人資料保護法」規定，必須向您告知的各項聲明，請您務必詳閱。)
        <br>{{ clinic.金安心.fullname }}
        LINE 官方帳號功能服務為{{ clinic.金安心.fullname }}經營管理，
        為確保消費者之個人資料、隱私及消費者權益之保護，
        於查詢過程中將使用消費者之個人資料，謹依個人資料保護法第8條規定告知以下事項：
        <br>
        <br>
        (一) 個人資料蒐集目的
        本院所之蒐集目的在於消費者、客戶管理與服務、保健醫療服務、資(通)訊服務(法定特定目的
        項目編號為 090, 064, 135)。 <br>
        (二) 個人資料蒐集類別 本院所於系統內蒐集的個人資料包括
        <br>1.C001辨識個人者： 如消費者之姓名、地址、電話、電子郵件等資訊。
        <br>2.C003政府資料中之辨識者： 如身分證字號或居留證號碼。
        <br>3.C011個人描述： 如性別、國籍、出生年月日。 <br>
        (三) 個人資料利用之期間、地區、對象及方式 <br>1.
        期間：本院所營運期間。 <br>2.
        地區：消費者之個人資料將用於本院所服務之地區。 <br>3.
        對象：本公司之合作推廣院所、業務往來之醫師、相關醫療人員、系統維護人員與提供本公司服務之第三方公司。
        <br>
        (四) 依據個資法第三條規定，您就本單位保有您的個人資料得行使下列權利
        查詢、閱覽、複本、補充、更正、請求停止蒐集、請求停止處理、請求停止利用、請求刪除等權利。
        <br>
        <br>{{ clinic.金安心.fullname }}保有修訂本告知內容之權利，修正時亦同，以上條文參考自中華民國資料保護協會。
      </div>
    </div>
    <div
      class="label label--primary m5"
      @click="$emit('close')"
    >
      關閉視窗
    </div>
  </div>
</template>
<script>
import spiderman from '@/spiderman';

export default {
  props: {
    linePictureUrl: {
      type: String,
      default: spiderman.clinic.substitute,
    },
  },
  emits: ['close'],

  setup() {
    return {
      clinic: spiderman.clinic,
    };
  },
};
</script>
